import { cva } from 'class-variance-authority';

export const SelectTriggerVariants = cva(
  `
    flex items-center justify-between gap-[0.5rem] 
    w-full
    h-[2.25rem]

    px-[0.825rem]

    rounded-[0.5rem]

    text-[0.875rem]
    text-input-text
    transition-all

    bg-select-background

    hover:border-gradient-border

    data-[state=open]:shadow-[0_0_6px_var(--input-glow)]
    data-[state=open]:border-primary-active-border
    focus-visible:outline-none
    focus-visible:shadow-[0_0_6px_var(--input-glow)]
    focus-visible:border-primary-active-border
    cursor-pointer
`,
  {
    variants: {
      size: {
        default: '',
        sm: 'h-[2rem] text-[0.75rem]',
        lg: 'h-[2.75rem]',
      },
      outline: {
        true: 'border border-primary-active-border',
        false: 'border border-outline',
      },
    },
    defaultVariants: {
      size: 'default',
      outline: true,
    },
  },
);

export const SelectLabelVariants = cva(`
  absolute
  left-[0.5rem]
  -top-[0.55rem]

  px-[0.25rem]

  text-[0.75rem]
  text-primary-active
  leading-none

  bg-background

  z-[2]
  pointer-events-none
  select-none
`);

export const SelectMessageVariants = cva(
  `
  pl-2
  text-[0.75rem]
  `,
  {
    variants: {
      variant: {
        helper: 'text-primary',
        error: 'text-negative',
      },
    },

    defaultVariants: {
      variant: 'helper',
    },
  },
);
